import script from "./GroupUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupUpdate.vue?vue&type=script&setup=true&lang=js"

import "./GroupUpdate.vue?vue&type=style&index=0&id=7de17b85&lang=scss"

const __exports__ = script;

export default __exports__